var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 674,
    height: 397,
    viewBox: "0 0 674 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9349 206.018L247.382 206.019V397H96.2457L96.2475 396.524C42.219 391.61 0 349.263 0 297.75C0 256.381 27.2282 220.924 65.9349 206.018Z",
    fill: "#7FB741"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.767 206.019V255.644H668.386C669.914 262.947 670.714 270.488 670.714 278.201C670.714 343.812 612.811 397 541.384 397H260.918V206.019H397.767Z",
    fill: "#1494D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M456.454 80.0158C469.491 73.1214 484.629 69.1743 500.775 69.1743C549.778 69.1743 589.502 105.531 589.502 150.379C589.502 156.15 588.844 161.78 587.594 167.21C624.123 180.052 652.693 207.673 664.633 242.11L411.297 242.11L411.299 23.5587C431.238 37.6169 447.024 57.1703 456.454 80.0158Z",
    fill: "#FF911D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.865 0C358.886 0 379.622 5.50373 397.772 15.2107L397.77 192.485L96.6387 192.485C101.28 138.572 147.137 96.2424 203.023 96.2424C205.95 96.2424 208.85 96.3585 211.717 96.5863C226.213 41.0144 276.749 0 336.865 0Z",
    fill: "#DC4038"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small-logo.ab452e5a.svg";
export { ForwardRef as ReactComponent };